export const MONTHLY_REPORT_PDF_PROVIDER = {
  name: 'Infinite Speed Telecomunicaciones',
  ruc: '20603757794',
};

export const MONTHLY_REPORT_PDF_SERVICE_NAME = 'Internet Dedicado';
export const MONTHLY_REPORT_PDF_SERVICE_STATUS_LABEL = 'ACTIVO';
export const MONTHLY_REPORT_PDF_LOGO_PATH = 'assets/images/logo_infistel.png';
export const MONTHLY_REPORT_PDF_LOGO_FIT: [number, number] = [40, 40];

export const MONTHLY_REPORT_PDF_INCIDENTS_NOTE = 'No toda incidencia reduce la disponibilidad.';
export const MONTHLY_REPORT_PDF_EMPTY_INCIDENTS = 'Sin incidentes registrados durante el período.';
export const MONTHLY_REPORT_PDF_UNAVAILABLE_AVAILABILITY = 'Información de disponibilidad no disponible';

export const MONTHLY_REPORT_PDF_FOOTER_UNIT = 'Área de Ingeniería / NOC';
export const MONTHLY_REPORT_PDF_FOOTER_CONTACT = 'Tel.: +51 1 480 1702 · Email: noc@infistel.pe';
